// Define a global function — attaches to the window object
window.getHandbookLocation = function (el) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const url = window.location.href;

  if (el?.getAttribute("location")) {
    return parseInt(el.getAttribute("location"));
  }

  if (urlParams.get("loc")) {
    return parseInt(urlParams.get("loc"));
  }

  const sections = ["/handbook/", "/rhandbook/", "/ochandbook/"];
  const sectionLocations = {
    "/handbook/": 1,
    "/rhandbook/": 4,
    "/ochandbook/": 2,
  };
  for (const section of sections) {
    if (url.includes(section)) {
      return sectionLocations[section];
    }
  }

  const homePages = ["rindex.html", "ocindex.html"];
  const homePageLocations = {
    "rindex.html": 4,
    "ocindex.html": 2,
  };
  for (const homePage of homePages) {
    if (url.includes(homePage)) {
      return homePageLocations[homePage];
    }
  }

  const indicesPages = ["/indices", "/rindices", "/ocindices"];
  const indicesPageLocations = {
    "/indices": 1,
    "/ocindices": 2,
    "/rindices": 4,
  };
  for (const indicesPage of indicesPages) {
    if (url.includes(indicesPage)) {
      return indicesPageLocations[indicesPage];
    }
  }

  // If Appendix page has /ex_ or rappendix in the url, it's for external clients/UIDL clients
  const externalAppendixUrls = ["/ex_", "rappendix", "Outreach/"];
  for (const externalAppendixUrl of externalAppendixUrls) {
    if (url.includes(externalAppendixUrl)) {
      return 4;
    }
  }
  // If Appendix page has /ex_ or rappendix in the url, it's for external clients/UIDL clients

  if (url.includes("rpreface")) {
    return 4;
  }

  if (urlParams.get("loc")) {
    return parseInt(urlParams.get("loc"));
  }

  return 1;
};
